var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('w-card-content',{attrs:{"tag":"w-scroll-view"}},[_c('div',{staticClass:"container"},[_c('img',{staticClass:"img",attrs:{"src":_vm.url,"alt":_vm.$ct('signature-image').toString()}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }